// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-base{background:#434343!important;font-size:12px!important;opacity:1!important;z-index:2010!important}.tooltip-base.type-dark.place-left:after{border-left-color:#434343}.tooltip-base.type-dark.place-right:after{border-right-color:#434343}.tooltip-base.type-dark.place-top:after{border-top-color:#434343}.tooltip-base.type-dark.place-bottom:after{border-bottom-color:#434343}", ""]);
// Exports
module.exports = exports;
